import React, { useState } from 'react';
import MfaRecoveryForm from './MfaRecoveryForm';
import { mfaStyles as styles } from './mfaStyles';
import { useMfaDialog } from './useMfaDialog';

export default function MfaRecoveryDialog({ email, onClose }: { email: string; onClose: () => void }) {
    const [busy, setBusy] = useState(false);
    const panel = useMfaDialog(onClose, busy);
    return <div className={styles.overlay}><section ref={panel} role="dialog" aria-modal="true" aria-labelledby="mfa-recovery-title" className={`${styles.panel} max-h-[90vh] overflow-y-auto`}>
        <div className="flex items-center justify-between gap-4"><h1 id="mfa-recovery-title" className="text-2xl font-bold">Reset user MFA</h1><button className={styles.secondary} disabled={busy} onClick={onClose}>Close</button></div>
        <MfaRecoveryForm initialEmail={email} onBusyChange={setBusy} />
    </section></div>;
}
